export default __webpack_public_path__ + "static/media/step-3-ar.6778257e.png";